export default __webpack_public_path__ + "static/media/vivo-barefoot-shoes.7620844f.svg";